import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "count", "list"]
  static values = { maxFiles: Number }

  connect() {
    this.objectUrls = []
  }

  disconnect() {
    this.revokeObjectUrls()
  }

  render() {
    this.revokeObjectUrls()
    this.enforceMaxFiles()
    const files = this.previewFiles

    if (files.length === 0) {
      this.clear()
      return
    }

    this.previewTarget.hidden = false
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${files.length} ${files.length === 1 ? "photo" : "photos"} selected`
    }

    this.listTarget.innerHTML = ""
    files.forEach(({ file, index }) => this.listTarget.appendChild(this.thumbnailFor(file, index)))
  }

  clear() {
    this.previewTarget.hidden = true
    if (this.hasCountTarget) this.countTarget.textContent = ""
    if (this.hasListTarget) this.listTarget.innerHTML = ""
  }

  thumbnailFor(file, index) {
    const url = URL.createObjectURL(file)
    this.objectUrls.push(url)

    const figure = document.createElement("figure")
    figure.className = "dwm-photo-preview__item"

    const image = document.createElement("img")
    image.src = url
    image.alt = file.name
    image.loading = "lazy"

    const caption = document.createElement("figcaption")
    caption.textContent = file.name

    figure.appendChild(image)
    figure.appendChild(caption)
    figure.appendChild(this.removeButtonFor(file, index))
    return figure
  }

  remove(event) {
    const index = Number(event.currentTarget.dataset.fileIndex)
    if (Number.isNaN(index)) return

    const files = this.selectedFiles.filter((_, fileIndex) => fileIndex !== index)
    this.replaceInputFiles(files)
    this.render()
  }

  removeButtonFor(file, index) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "dwm-photo-preview__remove"
    button.dataset.action = "dwm-photo-preview#remove"
    button.dataset.fileIndex = index
    button.setAttribute("aria-label", `Remove ${file.name}`)
    button.title = `Remove ${file.name}`
    button.textContent = "x"
    return button
  }

  replaceInputFiles(files) {
    const transfer = new DataTransfer()
    files.forEach((file) => transfer.items.add(file))
    this.inputTarget.files = transfer.files
  }

  enforceMaxFiles() {
    if (!this.hasMaxFilesValue) return
    if (this.selectedFiles.length <= this.maxFilesValue) return

    this.replaceInputFiles(this.selectedFiles.slice(0, this.maxFilesValue))
  }

  revokeObjectUrls() {
    const urls = this.objectUrls || []
    urls.forEach((url) => URL.revokeObjectURL(url))
    this.objectUrls = []
  }

  get selectedFiles() {
    return Array.from(this.inputTarget.files || [])
  }

  get previewFiles() {
    return this.selectedFiles
      .map((file, index) => ({ file, index }))
      .filter(({ file }) => file.type.startsWith("image/"))
  }
}
